(function () {
  var listeningSections = new WeakSet();
  var warmedUrls = new Set();
  var loadedUrls = new Set();
  var loadCallbacks = {};

  function onIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 2500 });
      return;
    }
    window.setTimeout(callback, 900);
  }

  function warmImage(url) {
    if (!url || warmedUrls.has(url)) return;
    warmedUrls.add(url);

    var image = new Image();
    image.decoding = 'async';
    image.onload = function () {
      var markLoaded = function () {
        loadedUrls.add(url);
        if (loadCallbacks[url]) {
          loadCallbacks[url].forEach(function (callback) {
            callback();
          });
          delete loadCallbacks[url];
        }
      };

      if (image.decode) {
        image.decode().catch(function () {}).then(function () {
          markLoaded();
        });
      } else {
        markLoaded();
      }
    };
    image.src = url;
  }

  function whenImageLoaded(url, callback) {
    if (loadedUrls.has(url)) {
      callback();
      return;
    }

    if (!loadCallbacks[url]) loadCallbacks[url] = [];
    loadCallbacks[url].push(callback);
  }

  function promoteImage(img, url) {
    if (!img || !url) return;

    img.src = url;
    img.srcset = url + ' 1600w';
    img.setAttribute('loading', 'eager');
    img.setAttribute('data-gallery-preloaded', 'true');

    var imageWrap = img.closest('.image');
    if (imageWrap) imageWrap.classList.add('loaded');
  }

  function applyPreloadedImage(productSection, mediaId) {
    if (!productSection || !mediaId) return;

    var wrappers = productSection.querySelectorAll('[data-product-media-wrapper][data-media-item-id="' + mediaId + '"][data-gallery-preload-src]');
    wrappers.forEach(function (wrapper) {
      var url = wrapper.getAttribute('data-gallery-preload-src');
      var img = wrapper.querySelector('img.image__img');
      if (!url || !img) return;

      if (loadedUrls.has(url)) {
        promoteImage(img, url);
        return;
      }

      warmImage(url);
      whenImageLoaded(url, function () {
        promoteImage(img, url);
      });
    });
  }

  function initProductGallery(productSection) {
    if (!productSection) return;

    var wrappers = Array.prototype.slice.call(productSection.querySelectorAll('[data-product-media-wrapper][data-gallery-preload-src]'));
    if (!wrappers.length) return;

    var initialMediaId = productSection.getAttribute('data-initial-media-id');
    var urls = wrappers
      .filter(function (wrapper) {
        return wrapper.getAttribute('data-media-type') === 'image'
          && wrapper.getAttribute('data-media-item-id') !== initialMediaId;
      })
      .map(function (wrapper) {
        return wrapper.getAttribute('data-gallery-preload-src');
      })
      .filter(Boolean);

    onIdle(function () {
      urls.forEach(warmImage);
    });

    if (listeningSections.has(productSection)) return;
    listeningSections.add(productSection);

    productSection.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('[data-product-thumbnail]');
      if (!thumbnail || !productSection.contains(thumbnail)) return;
      applyPreloadedImage(productSection, thumbnail.getAttribute('data-thumbnail-id'));
    }, true);
  }

  function initAllProductGalleries(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('[data-section-type="product"]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      sections.push(section);
    });

    sections.forEach(initProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductGalleries(document);
    });
  } else {
    initAllProductGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllProductGalleries(event.target);
  });

  document.addEventListener('product:variant-change', function () {
    window.setTimeout(function () {
      initAllProductGalleries(document);
    }, 300);
  });

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-media-wrapper], [data-section-type="product"]')) {
            initAllProductGalleries(node.closest('[data-section-type="product"]') || node);
            return;
          }
          if (node.querySelector && node.querySelector('[data-product-media-wrapper][data-gallery-preload-src]')) {
            initAllProductGalleries(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
